module.exports = __webpack_public_path__ + "static/media/Singed.61bdcef1.png";